export const env = {
  API_URL: import.meta.env.VITE_API_URL,
  RENTABLE_URL: import.meta.env.VITE_RENTABLE_URL,
  ENABLE_GOOGLE_ANALYTICS: import.meta.env.VITE_ENABLE_GOOGLE_ANALYTICS == "true",
  ENVIRONMENT_NAME: import.meta.env.VITE_ENVIRONMENT_NAME,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN
};
